import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { SupportLinkKeys } from 'automation-ui-usage-tracking/SupportLinks';
import DocButton from 'automation-ui-usage-tracking/components/DocButton';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CustomCodeActionExplainer(__props) {
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "automation-ui-action-features.action-features.custom-code.explainer_jsx",
    elements: {
      Bold: 'strong',
      SupportLink: () => /*#__PURE__*/_jsx(DocButton, {
        supportKey: SupportLinkKeys.CUSTOM_CODE_HELP
      })
    }
  });
}